// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U2MX","tabsBox":"styles_tabsBox__3gWdF","createButton":"styles_createButton__MdFuD"};